import { UserEvalPageData } from '@modules/EvaluationModule/interfaces/UserEvalPageData';
import { createAction } from '@reduxjs/toolkit';
import { AsyncData } from 'shared/interfaces/asyncData';

export const getUserEvalData = createAction<string>('userEvalPage/getUserEvalData');
export const setUserEvalData = createAction<AsyncData<UserEvalPageData>>('userEvalPage/setUserEvalData');
export const setUserEvalDataLoading = createAction<void>('userEvalPage/setUserEvalDataLoading');
export const startEvalOnUserEvalPage = createAction<string>('userEvalPage/startEval');
